import Product from "@/domain/product/Product";

interface IThemeBanner {
  bannerId: number;
  bannerText: string;
  bannerSubText: string;
  backgroundImageUrl: string;
  productList: Array<Product>;
}

class ThemeBanner {
  constructor(args: IThemeBanner) {
    return Object.assign(this, args);
  }
}

interface ThemeBanner extends IThemeBanner {
}

export default ThemeBanner;